export const CURRENCY_OPTIONS = [
  { value: 'dh', label: 'DH (Moroccan Dirham)' },
  { value: 'DZD', label: 'DZD (Algerian Dinar)' },
  { value: 'EGP', label: 'E£ (Egyptian Pound)' },
  { value: 'DT', label: 'DT (Tunisian Dinar)' },
  { value: '$', label: '$ (US Dollar)' },
  { value: '€', label: '€ (Euro)' },
  { value: '£', label: '£ (British Pound)' },
  { value: '¥', label: '¥ (Japanese Yen)' },
  { value: '₹', label: '₹ (Indian Rupee)' },
  { value: '₩', label: '₩ (South Korean Won)' },
  { value: '₽', label: '₽ (Russian Ruble)' },
  { value: '₴', label: '₴ (Ukrainian Hryvnia)' },
  { value: '₺', label: '₺ (Turkish Lira)' },
  { value: 'A$', label: 'A$ (Australian Dollar)' },
  { value: 'C$', label: 'C$ (Canadian Dollar)' },
  { value: 'R$', label: 'R$ (Brazilian Real)' },
  { value: 'NZ$', label: 'NZ$ (New Zealand Dollar)' },
  { value: 'HK$', label: 'HK$ (Hong Kong Dollar)' },
  { value: 'SG$', label: 'SG$ (Singapore Dollar)' },
  { value: 'R', label: 'R (South African Rand)' },
  { value: 'AOA', label: 'AOA (Angolan Kwanza)' },
  { value: 'XOF', label: 'XOF (West African CFA Franc)' },
  { value: 'BWP', label: 'BWP (Botswana Pula)' },
  { value: 'CDF', label: 'CDF (Congolese Franc)' },
  { value: 'XAF', label: 'XAF (Central African CFA Franc)' },
  { value: 'DJF', label: 'DJF (Djiboutian Franc)' },
  { value: 'ERN', label: 'ERN (Eritrean Nakfa)' },
  { value: 'ETB', label: 'ETB (Ethiopian Birr)' },
  { value: 'GHS', label: 'GHS (Ghanaian Cedi)' },
  { value: 'GMD', label: 'GMD (Gambian Dalasi)' },
  { value: 'GNF', label: 'GNF (Guinean Franc)' },
  { value: 'KES', label: 'KES (Kenyan Shilling)' },
  { value: 'KMF', label: 'KMF (Comorian Franc)' },
  { value: 'LRD', label: 'LRD (Liberian Dollar)' },
  { value: 'LSL', label: 'LSL (Lesotho Loti)' },
  { value: 'LYD', label: 'LYD (Libyan Dinar)' },
  { value: 'MGA', label: 'MGA (Malagasy Ariary)' },
  { value: 'MWK', label: 'MWK (Malawian Kwacha)' },
  { value: 'MRU', label: 'MRU (Mauritanian Ouguiya)' },
  { value: 'MUR', label: 'MUR (Mauritian Rupee)' },
  { value: 'MZN', label: 'MZN (Mozambican Metical)' },
  { value: 'NAD', label: 'NAD (Namibian Dollar)' },
  { value: 'NGN', label: '₦ (Nigerian Naira)' },
  { value: 'RWF', label: 'RWF (Rwandan Franc)' },
  { value: 'SCR', label: 'SCR (Seychellois Rupee)' },
  { value: 'SDG', label: 'SDG (Sudanese Pound)' },
  { value: 'SHP', label: 'SHP (Saint Helena Pound)' },
  { value: 'SLL', label: 'SLL (Sierra Leonean Leone)' },
  { value: 'SOS', label: 'SOS (Somali Shilling)' },
  { value: 'SSP', label: 'SSP (South Sudanese Pound)' },
  { value: 'STN', label: 'STN (São Tomé and Príncipe Dobra)' },
  { value: 'SZL', label: 'SZL (Swazi Lilangeni)' },
  { value: 'TZS', label: 'TZS (Tanzanian Shilling)' },
  { value: 'UGX', label: 'UGX (Ugandan Shilling)' },
  { value: 'ZMW', label: 'ZMW (Zambian Kwacha)' },
  { value: 'ZWL', label: 'ZWL (Zimbabwean Dollar)' }
]
